



















































import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import { gridConfig } from '@core/config/grid.config';
import ArticleHeadline from './ArticleHeadline.vue';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import getArticleUrl from '@root/modules/article/utils/buildArticleUrl';

interface Props {
  article: ArticleData;
  type: string;
}

interface Methods {
  addClickData: (headline: HeadlinesData, params: Record<string, any>) => Record<string, any>;
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getArticleHeadlines: (relatedHeadlineIds: number[]) => Promise<HeadlinesData[]>;
}

interface Computed {
  ptMiddleArticles: number[];
  ptBottomArticles: number[];
  disableAds: boolean;
}

interface Data {
  domains: string | string[];
  locale: string;
  language: string;
  ptMiddleHeadlines: HeadlinesData[];
  ptBottomHeadlines: HeadlinesData[];
  headlinesLimit: number;
  isMobileView: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ArticleHeadline,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    const { domain, locale, temporaryAllowedDomains, lang } = this.$channelConfig('settings');
    const domains = temporaryAllowedDomains ? [...new Set([...temporaryAllowedDomains, domain])] : domain;
    return {
      domains,
      locale,
      language: lang.toUpperCase(),
      ptMiddleHeadlines: [],
      ptBottomHeadlines: [],
      headlinesLimit: 10,
      isMobileView: false,
    };
  },
  computed: {
    ptMiddleArticles() {
      const articleExtra = this.$store.getters['article/getArticleExtraContent'];
      return articleExtra && articleExtra.pt_middle?.length > 0 ? articleExtra.pt_middle : null;
    },
    ptBottomArticles() {
      const articleExtra = this.$store.getters['article/getArticleExtraContent'];
      return articleExtra && articleExtra.pt_bottom?.length > 0 ? articleExtra.pt_bottom : null;
    },
    disableAds() {
      return this.article.banners.disableAds;
    },
  },
  watch: {
    ptMiddleArticles: {
      async handler(articleExtra) {
        if (articleExtra) {
          this.ptMiddleHeadlines = await this.getArticleHeadlines(articleExtra);
        }
      },
      immediate: true,
    },
    ptBottomArticles: {
      async handler(articleExtra) {
        if (articleExtra) {
          this.ptBottomHeadlines = await this.getArticleHeadlines(articleExtra);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (process.client) {
      const screenWidth = window.screen.width;
      this.isMobileView = screenWidth <= gridConfig.breakpoints.lg;
    } else {
      this.isMobileView = this.$ua && this.$ua.deviceType() === 'smartphone' && !this.$ua.isFromTablet();
    }
  },
  methods: {
    addClickData(headline: HeadlinesData, params: Record<string, any>) {
      const clickData: Record<string, any> = {};

      clickData.articleLayout = 'a';
      clickData.listType = params.listType;
      clickData.listPosition = params.listPosition;
      clickData.listArticleId = headline.id;
      clickData.listArticleUrl = getArticleUrl({ article: headline, domain: headline.primaryCategory.channel.url });
      clickData.listArticlePosition = params.listIndex;

      return { ...headline, clickData };
    },
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domains, fakeDomainEnabled });
    },
    async getArticleHeadlines(ids) {
      const universalHeadlinesService = new UniversalHeadlinesService();
      // FIX ME: Removed language: this.language variable as content-api-v3 has now channel.language: "ET" imported;
      const headlines = await universalHeadlinesService.fetch({ id: ids, limit: this.headlinesLimit });
      return headlines.items;
    },
  },
});
